export default "__VITE_ASSET__ja7bUxjW__"